import * as fetchingApi from '@services/fetchingApi'
import { webApi2OldBuildUrl, webApiBuildUrl } from '@api/utils'

export const sendFeedBack = (data) => fetchingApi.Post(webApiBuildUrl('api/company/feedback'), data)
export const getCompanyStock = (companyId) => fetchingApi.Get(webApiBuildUrl(`api/company/${companyId}/stocks`))
export const getRule = (ruleId) => fetchingApi.Get(webApiBuildUrl(`api/company/rules/${ruleId}`))
export const getApiVersion = () => fetchingApi.Get(webApiBuildUrl('api/company/version'), null, false)
export const getApi2Version = () => fetchingApi.Get(webApi2OldBuildUrl('version'), null, false)
